var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGaugePointer = function SvgGaugePointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25.6 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,0.7l12,40.1H0.7L12.8,0.7z"
  })));
};
export { SvgGaugePointer as ReactComponent };